import type { Content } from 'core/domains';

export const initialState: Content = {};
